import { Result } from 'antd';

export function NoAccessibleRoutePage() {
  return <Result status="403" title="403" subTitle="当前账号没有可访问页面" />;
}
